import React from "react";
import BrandLogo from "../../../assets/images/logo/buzzLogo.svg";
import "./header.scss";
import { Link } from "gatsby";

const NAV_ITEMS = [
  {
    id: "articles",
    title: "Articles",
    link: "/",
  },
  {
    id: "calculators",
    title: "Calculators",
    link: "/calculators/",
  },
];

const ACTIVE_LINK_COLOR = "#72EF9C";

const Header = () => {
  return (
    <header className="header">
      <div className="header-wrapper">
        <a href="/buzz">
          <img
            src={BrandLogo}
            className="logo"
            alt="Share.Market Buzz logo"
          />
        </a>
        <div className="nav-items">
          {NAV_ITEMS.map(item => (
            <Link
              to={item.link}
              className="nav-item"
              key={item.id}
              activeStyle={{ color: ACTIVE_LINK_COLOR }}
            >
              {item.title}
            </Link>
          ))}
        </div>
      </div>
    </header>
  );
};

export default Header;
